import {axiosInstance} from "../lib/axios";

const membershipService = {
  list(params) {
    return axiosInstance.get("/membership-types", {params}).then((r) => r.data);
  },
  create(payload) {
    return axiosInstance.post("/membership-types", payload).then((r) => r.data);
  },
  update(id, payload) {
    return axiosInstance
      .patch(`/membership-types/${id}`, payload)
      .then((r) => r.data);
  },
  remove(id) {
    return axiosInstance.delete(`/membership-types/${id}`).then((r) => r.data);
  },
  assignToEnrollment(payload) {
    return axiosInstance
      .post("/membership-types/assign", payload)
      .then((r) => r.data);
  },
};

export default membershipService;
